<template>
    <div class="header px-10 text-xl font-principal text-principal-gray bg-white h-16 font-medium flex-initial">
        <div class="mobile-header">
            <b-icon-list @click="toggleNav($event)" class="h1 mb-0"></b-icon-list>
            <div>Tableau de bord</div>
        </div>
        <div class="desktop-header">
            <div class="flex">
                <router-link to="/">
                    <div class="hover:text-gray-header-hover">{{title}}</div>
                </router-link>
                <v-select
                    class="twn-select min-w-96 text-base ml-8"
                    placeholder="Tous les parcours"
                    :value="selectedCourseId"
                    @input="(courseId) => $store.commit('Utils/SET_SELECTED_COURSE_ID', courseId)"
                    :getOptionLabel="getCourseLabel"
                    :options="courseList"
                    :filterable="true"
                    :reduce="course => course.id"
                    :clearable="!isUserInstructor"
                />
            </div>
            <div @click="logout" class="cursor-pointer">Déconnexion</div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Header',
    computed:{
        ...mapState({
            courseList: state => state.Course.list,
            selectedCourseId: state => state.Utils.selectedCourseId,
        }),
        ...mapState('Auth', [ 'userInfo' ]),
        isUserInstructor() {
            return (this.userInfo && this.userInfo.role == 'instructor')
        },
        title() {
            if (this.$route.meta.titleFn) {
                return this.$route.meta.titleFn(this.$route, this.$store)
            }

            return this.$route.meta.title
        },
    },
    watch: {
        isUserInstructor: {
            handler() {
                if (this.isUserInstructor && !this.selectedCourseId && this.courseList.length) {
                    this.$store.commit('Utils/SET_SELECTED_COURSE_ID', this.courseList[0].id)
                }
            },
            immediate: true,
        },
        courseList: {
            handler() {
                if (this.isUserInstructor && !this.selectedCourseId && this.courseList.length) {
                    this.$store.commit('Utils/SET_SELECTED_COURSE_ID', this.courseList[0].id)
                }
            },
            immediate: true,
        },
    },
    async mounted() {
        // Load course list if needed
        if (!this.courseList.length) {
            await this.$store.dispatch('Course/getList')
        }
    },
    methods: {
        ...mapActions('Header', ['toggleNav']),
        getCourseLabel(course) {
            if (!course) {
                return 'Utilisateur supprimé'
            }

            return [course.identifier, course.title].filter(str => str || false).join(' - ')
        },
        async logout() {
            try {
                await this.$store.dispatch('Auth/logout')
                await this.$router.push({ name: 'auth' })
            } catch (error) {
                location.reload()
            }
        },
    },
}
</script>

<style lang="scss">

.header{
    border-bottom: 1px solid rgba(0,0,0,0.2);
}

.header > div {
    @apply flex-row justify-between items-center h-full;
    &.desktop-header{
        @apply hidden;
        @screen md {
            @apply flex;
        }
    }
    &.mobile-header{
        @apply flex;
        @screen md {
            @apply hidden;
        }
    }
}
</style>